import { handleActions } from 'redux-actions';
import _ from 'lodash';
import { constants } from './actions';


const INITIAL_STATE = {
};

function handleShowMessage(state, { payload }) {
  if (!payload) return state;

  const { messageId, messageContent } = payload;
  if (!messageId) return state;

  return {
    ...state,
    [messageId]: messageContent,
  };
}

function handleClearMessage(state, { payload }) {
  if (!payload) return state;

  const { messageId } = payload;
  if (!messageId) return state;

  return _.omit(state, [messageId]);
}

export default handleActions({
  [constants.showNotificationMessage]: handleShowMessage,
  [constants.clearNotificationMessage]: handleClearMessage,
}, INITIAL_STATE);
